import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  INovaplaceBanner,
  INovaplaceBusinessActionLink,
  INovaplaceBusinessActionPayload,
  INovaplaceBusinessClosePayload,
  INovaplaceBusinessContactsPayload,
  INovaplaceBusinessFocusPayload,
} from '../shared/components/banner/banner.models';
import { ConfigService } from './config.service';
import { NoRestApiHelper } from './no-rest-api.helper';

@Injectable({
  providedIn: 'root',
})
export class ShoppingApiService {
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private noRestApiHelper: NoRestApiHelper,
  ) {
  }

  businessContacts(methodProperties: INovaplaceBusinessContactsPayload): Observable<INovaplaceBanner[]> {
    return this.http
      .post(`${this.configService.get('apiUrl')}json/`, {
        system: this.configService.get('system'),
        modelName: 'NovaplaceGeneral',
        calledMethod: 'businessContacts',
        methodProperties,
      })
      .pipe(
        map((data) => this.noRestApiHelper.checkErrors({ data })),
        map((response) => response.data.data),
      );
  }

  businessFocus(methodProperties: INovaplaceBusinessFocusPayload): Observable<INovaplaceBanner[]> {
    return this.http
      .post(`${this.configService.get('apiUrl')}json/`, {
        system: this.configService.get('system'),
        modelName: 'NovaplaceGeneral',
        calledMethod: 'businessFocus',
        methodProperties,
      })
      .pipe(
        map((data) => this.noRestApiHelper.checkErrors({ data })),
        map((response) => response.data.data),
      );
  }

  businessAction(methodProperties: INovaplaceBusinessActionPayload): Observable<INovaplaceBusinessActionLink> {
    return this.http
      .post(`${this.configService.get('apiUrl')}json/`, {
        system: this.configService.get('system'),
        modelName: 'NovaplaceGeneral',
        calledMethod: 'businessAction',
        methodProperties,
      })
      .pipe(
        map((data) => this.noRestApiHelper.checkErrors({ data })),
        map((response) => response.data[0]),
      );
  }

  businessClose(methodProperties: INovaplaceBusinessClosePayload): Observable<void> {
    return this.http
      .post(`${this.configService.get('apiUrl')}json/`, {
        system: this.configService.get('system'),
        modelName: 'NovaplaceGeneral',
        calledMethod: 'businessClose',
        methodProperties,
      })
      .pipe(
        map((data) => this.noRestApiHelper.checkErrors({ data })),
        map((response) => response.data.data),
      );
  }
}
